//金额格式化
export const formatMoney = (value, decimals) => {
  if (!value && value !== 0) return '';
  if (isNaN(value)) return value;
  value = +value;
  const base = 10000;
  const units = ['', '万', '亿', '万亿'];
  if (value < base) {
    return value;
  } else {
    const i = Math.floor(Math.log(value) / Math.log(base));
    const val = (value / Math.pow(base, i)).toFixed(decimals || 0);
    return `${val}${units[i]}`;
  }
};
//日期时间格式化
export const formatDate = (date) => {
  window.console.log(date)
  const d = new Date(date)
  const y = d.getFullYear() // 年份
  const m = (d.getMonth() + 1).toString().padStart(2, '0') // 月份
  const r = d.getDate().toString().padStart(2, '0') // 日子
  const hh = d.getHours().toString().padStart(2, '0') // 小时
  const mm = d.getMinutes().toString().padStart(2, '0') // 分钟
  const ss = d.getSeconds().toString().padStart(2, '0') // 秒
  return `${y}-${m}-${r} ${hh}:${mm}:${ss}`
}

export const formatByPath = (keys, value) => {
  if (keys && keys.length === 0) {
    return value;
  }

  const findNode = (key, nodes) => {
    return nodes.find(node => node.value === key);
  };

  let i = 0;
  let nodes = getCategories();
  let node = null;
  while (i < keys.length) {
    node = findNode(keys[i], nodes);
    nodes = node.children;
    i++;
  }
  if (node) {
    return node.fn(value);
  } else {
    value;
  }
};

export const getCategories = () => [
  {
    value: 'jine',
    label: '金额',
    children: [
      {
        value: 'auto',
        label: '自动格式化',
        fn: formatMoney
      }
    ]
  },{
    value:'riqi',
    label:'日期',
    children: [
      {
        value:'auto',
        label:'自动格式化',
        fn: formatDate
      }
    ]
  }
];
